const setWrapperHeight = (el: string) => {
  const n = document.querySelector(el) as HTMLElement;
  if (n) n.style.height = `${window.innerHeight}px`;
};
export default setWrapperHeight;
